import React from 'react';
import { TextField, InputLabel } from '@mui/material';

interface DatePickerProps {
    id: string;
    name: string;
    value: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    title?:string;
    label?: string;
    minDate?: Date;
    maxDate?: Date;
    labelMargin?:any;
    error?: boolean;
    helperText?: string;
}

const DatePicker: React.FC<DatePickerProps> = ({
    id,
    name,
    value,
    title,
    label,
    onChange,
    minDate,
    maxDate,
    labelMargin,
    error,
    helperText
}) => {
    const minDateString = minDate ? minDate.toISOString().split('T')[0] : undefined;
    const maxDateString = maxDate ? maxDate.toISOString().split('T')[0] : undefined;
    let width = '150px'
    let marginLeft = '0px'
    let marginRight = '16px'
if(id === 'regDate'){
    width = '225px';
    marginLeft = '-8px';
}
else if (id === 'registrationDate'){
    width = '200px';
}
else if(id === 'regiDate'){
    width = '225px';
    marginLeft = '7px';
    marginRight='0px';
    
}
    return (
        <div style={{ display: 'flex', alignItems: 'center', marginRight: marginRight, marginLeft:marginLeft }}>
            <InputLabel htmlFor={id} style={{ marginRight: labelMargin || '8px', color: 'black' }}>{title}</InputLabel>
            <TextField
                type="date"
                id={id}
                label={label}
                name={name}
                value={value}
                onChange={onChange}
                variant="outlined"
                style={{ backgroundColor: 'white', width: width, height: '40px', marginLeft:marginLeft }}
                InputProps={{
                    style: { height: '40px' }
                }}
                InputLabelProps={{
                    shrink: true,
                }}
                inputProps={{
                    ...(minDateString && { min: minDateString }),
                    ...(maxDateString && { max: maxDateString })
                }}
                error={error}
                helperText={helperText}
            />
        </div>
    );
};

export default DatePicker;
